import {cloneElement, h, toChildArray} from "preact";
import {FormContext} from "@src/components/form";
import {useEffect, useMemo, useRef, useState} from "preact/hooks";
import useMount from "@src/utils/hooks/use-mount";
import cx from "classnames";
import "./index.less";

const FormItem = ({children, validateTrigger = 'onChange', name, rules}) => {
  const filedArgument = {children, validateTrigger, name, rules}
  const [error, setError] = useState('');
  const [focusStatus, setFocus] = useState(false);
  const elementRef = useRef(null);
  const collectRef = useRef(() => {
  });
  const filedElement = useRef();
  const clearCollect = useRef(() => {
  });
  const formRef = useRef(null);
  const isShowError = useMemo(() => {
    return error&&!focusStatus;
  },[error, focusStatus])
  useMount(() => {
    const formStore = collectRef.current();
    formRef.current = formStore
    return () => {
      clearCollect.current();
    }
  })
  useEffect(() => {
    if(filedElement.current){
      filedElement.current.addEventListener('focus',() => {
        setFocus(true);
      });
      filedElement.current.addEventListener('blur',() => {
        setFocus(false);
      });
    }
  },[filedElement.current]);
  useEffect(() => {
    if (formRef.current) {
      formRef.current.collectFiledRef(name, elementRef);
    }
  }, [elementRef.current, formRef.current])
  return <FormContext.Consumer>
    {(form) => {
      collectRef.current = () => {
        form.formStore.collectField(name);
        form.formStore.collectFiledRule(name, rules);
        form.formStore.collectFiledError(name, setError);
        form.formStore.collectFiledRef(name, elementRef);
        return form.formStore;
      }
      clearCollect.current = () => {
        form.formStore.clearFiledCollectInfo(name);
      }
      return (<div className={cx('xfe_common_form_item_root', (error&&!focusStatus) && 'has_error', focusStatus && 'focus')} ref={elementRef}>
        {
          toChildArray(children).map(child => {
            if (typeof child === 'object') {
              return cloneElement(child, {
                value: form.formValue[name],
                ref: filedElement,
                onInput: (e) => {
                  form.formStore.onFieldValueChange(filedArgument,{[name]: e.target.value});
                },
                [validateTrigger]: (e) => {
                  form.formStore.changeFieldValue(filedArgument,{[name]: e.target.value}).finally();
                }
              })
            }
            return child;
          })
        }
        {error && <span className={cx('xfe_common_form_item_error', isShowError && "show")}>{!focusStatus? error: ''}</span>}
      </div>)
    }}
  </FormContext.Consumer>
}

export default FormItem;
